import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const WORDS    = ['them', 'her', 'him', 'she', 'he', 'they', 'us'];
const DURATION = 2800;

export default function WordCycler() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % WORDS.length);
    }, DURATION);
    return () => clearInterval(timer);
  }, []);

  return (
    <span
      style={{
        display:       'inline-block',
        minWidth:      '4ch',
        textAlign:     'left',
        fontWeight:    400,
        position:      'relative',
        overflow:      'hidden',
        height:        '1.15em',
        verticalAlign: 'top',
        cursor:        'default',
      }}
    >
      <AnimatePresence mode="wait">
        <motion.span
          key={WORDS[index]}
          initial={{ opacity: 0, y: '100%' }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: '-100%' }}
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
          style={{
            display:    'block',
            position:   'absolute',
            left:       0,
            width:      '100%',
            height:     '100%',
            lineHeight: 1,
            color:      'var(--text)',
          }}
        >
          {WORDS[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
